import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable ,  of } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class HttpCacheInterceptor implements HttpInterceptor {

  private cache;

  constructor() {
    this.cache = [];
  }

  /**
   * Intercepter that will memoize HTTP requests and store the results
   * @param {HttpRequest} req - the http request being executed
   * @param {HttpHandler} next - the next step in the http chain
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

  	// Skip non-GET requests
    if (req.method !== 'GET') return next.handle(req);

    // Serve the cached response if we have it
    const cachedResponse = this.cache[req.urlWithParams];
    if (cachedResponse) {
      return of(cachedResponse);
    }

    // No cached response, so handle the request then cache the result
    return next.handle(req).pipe(tap((data) => {
      if (data instanceof HttpResponse) {
        this.cache[req.urlWithParams] = data;
      }
    }));
  }
}